export const SYSTEM_ORDER_TEMPLATES = [
  {
    id: "tpl_kremace_bez_obradu_standard",
    name: "Kremace bez obřadu – standard",
    prubehKey: "bez_obradu",
    isSystem: true,
    data: {
      zaklad: {
        typZakazky: "kremace_bez_obradu",
        scenarUmrti: "nemocnice_ck",
        navazujiciObradSUrnou: false,
      },
      prevoz: {
        dopravaMode: "pausal_cb",
      },
      sluzby: [
        { id: "sjednani_zpopelneni_bez_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "kremace", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rakev", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "umyvani_obleceni_ulozeni_ustrojeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "holeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "manipulace_rakvi_nositky", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "prevoz_krematorium_cb", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "cekaci_doba_zapocata_hod", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "ukony_zamestnancu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rezijni_naklady_bez_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "privezeni_urny_cb", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
      ],
    },
  },
  {
    id: "tpl_kremace_bez_obradu_urna",
    name: "Kremace bez obřadu + následné rozloučení s urnou",
    prubehKey: "bez_obradu_urna",
    isSystem: true,
    data: {
      zaklad: {
        typZakazky: "kremace_bez_obradu",
        scenarUmrti: "doma",
        navazujiciObradSUrnou: true,
      },
      prevoz: {
        dopravaMode: "combo_cb",
        bezObraduScenar: "doma_nebo_mimo_ck_nemocnici",
      },
      sluzby: [
        { id: "sjednani_zpopelneni_bez_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "sjednani_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "kremace", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rakev", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "umyvani_obleceni_ulozeni_ustrojeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "holeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "manipulace_rakvi_nositky", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "prevoz_krematorium_cb", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "cekaci_doba_zapocata_hod", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "ukony_zamestnancu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rezijni_naklady_bez_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "manipulace_urnou", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rizeni_pohrebu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "privezeni_urny_cb", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "pronajem_obradni_sin", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "reprodukovana_hudba", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
      ],
    },
  },
  {
    id: "tpl_kremace_bez_obradu_vystaveni",
    name: "Kremace bez obřadu + vystavení zesnulého",
    prubehKey: "bez_obradu_vystaveni",
    isSystem: true,
    data: {
      zaklad: {
        typZakazky: "kremace_bez_obradu",
        scenarUmrti: "nemocnice_ck",
        navazujiciObradSUrnou: false,
      },
      obrad: {
        misto: "Obřadní síň Český Krumlov",
        mistoId: "obradni_sin_ck",
        mistoSkupina: "obradni_sin",
        ceremonyVariant: "vystaveni",
      },
      prevoz: {
        dopravaMode: "pausal_cb",
      },
      sluzby: [
        { id: "sjednani_zpopelneni_bez_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "kremace", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rakev", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "umyvani_obleceni_ulozeni_ustrojeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "holeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "manipulace_rakvi_nositky", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "prevoz_krematorium_cb", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "cekaci_doba_zapocata_hod", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "ukony_zamestnancu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rezijni_naklady_bez_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "privezeni_urny_cb", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" }
      ],
    },
  },


  {
    id: "tpl_kremace_s_obradem",
    name: "Kremace s obřadem – nemocnice ČK / obřadní síň ČK / následná kremace",
    prubehKey: "obradni_sin_ck_nasledna_kremace",
    isSystem: true,
    data: {
      zaklad: {
        typZakazky: "kremace",
        scenarUmrti: "nemocnice_ck",
      },
      prevoz: {
        dopravaMode: "km",
      },
      sluzby: [
        { id: "sjednani_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "kremace", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "prevoz_pausal_ck", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "prevoz_krematorium_cb", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "cekaci_doba_zapocata_hod", mnozstvi: 2, cenaBezDphOverride: "", rakevId: "" },
        { id: "manipulace_rakvi_nositky", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "ukony_zamestnancu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rezijni_naklady", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rizeni_pohrebu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "pronajem_obradni_sin", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "reprodukovana_hudba", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "umyvani_obleceni_ulozeni_ustrojeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
      ],
    },
  },

  {
    id: "tpl_kremace_obrad_doma_ck_nasledna",
    name: "Kremace s obřadem – úmrtí doma / obřadní síň ČK / následná kremace",
    prubehKey: "obradni_sin_ck_nasledna_kremace",
    isSystem: true,
    data: {
      zaklad: {
        typZakazky: "kremace",
        scenarUmrti: "doma",
      },
      prevoz: {
        dopravaMode: "km",
      },
      sluzby: [
        { id: "sjednani_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "kremace", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "prevoz_krematorium_cb", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "cekaci_doba_zapocata_hod", mnozstvi: 2, cenaBezDphOverride: "", rakevId: "" },
        { id: "manipulace_rakvi_nositky", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "ukony_zamestnancu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rezijni_naklady", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rizeni_pohrebu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "pronajem_obradni_sin", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "reprodukovana_hudba", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "umyvani_obleceni_ulozeni_ustrojeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "stejnokroj_osoba", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "privezeni_urny_cb", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "souprava", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "promitani_fotografii", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "umrtni_oznameni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "kvetinova_vyzdoba", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "vystaveni_kytice_ks", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" }
      ],
    },
  },


  {
    id: "tpl_kremace_obrad_wagnerka_ck_nasledna",
    name: "Kremace s obřadem – Wagnerka / obřadní síň ČK / následná kremace",
    prubehKey: "obradni_sin_ck_nasledna_kremace",
    isSystem: true,
    data: {
      zaklad: {
        typZakazky: "kremace",
        scenarUmrti: "wagnerka",
      },
      prevoz: {
        dopravaMode: "km",
        coolingScenario: "wagnerka",
      },
      sluzby: [
        { id: "sjednani_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "kremace", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "prevoz_krematorium_cb", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "cekaci_doba_zapocata_hod", mnozstvi: 2, cenaBezDphOverride: "", rakevId: "" },
        { id: "manipulace_rakvi_nositky", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "ukony_zamestnancu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rezijni_naklady", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rizeni_pohrebu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "pronajem_obradni_sin", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "reprodukovana_hudba", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "umyvani_obleceni_ulozeni_ustrojeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "stejnokroj_osoba", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "privezeni_urny_cb", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "souprava", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "promitani_fotografii", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "umrtni_oznameni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "kvetinova_vyzdoba", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "vystaveni_kytice_ks", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" }
      ],
    },
  },


  {
    id: "tpl_kremace_kostel_nasledna",
    name: "Kremace s obřadem – kostel / následná kremace",
    prubehKey: "kostel_nasledna_kremace",
    isSystem: true,
    data: {
      zaklad: {
        typZakazky: "kremace",
        scenarUmrti: "nemocnice_ck",
      },
      prevoz: {
        dopravaMode: "km",
      },
      sluzby: [
        { id: "sjednani_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "kremace", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "prevoz_krematorium_cb", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "cekaci_doba_zapocata_hod", mnozstvi: 2, cenaBezDphOverride: "", rakevId: "" },
        { id: "manipulace_rakvi_nositky", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "ukony_zamestnancu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rezijni_naklady", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rizeni_pohrebu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "umyvani_obleceni_ulozeni_ustrojeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "privezeni_urny_cb", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" }
      ],
    },
  },

  {
    id: "tpl_umrti_doma_rozlouceni_cb_krematorium",
    name: "Kremace s obřadem – úmrtí doma / rozloučení v ČB krematoriu",
    prubehKey: "cb_krematorium_rozlouceni",
    isSystem: true,
    data: {
      zaklad: {
        typZakazky: "kremace",
        scenarUmrti: "doma",
      },
      prevoz: {
        dopravaMode: "km",
      },
      sluzby: [
        { id: "sjednani_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "kremace", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "umyvani_obleceni_ulozeni_ustrojeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "prevoz_pausal_ck", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "prevoz_krematorium_cb", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "cekaci_doba_zapocata_hod", mnozstvi: 2, cenaBezDphOverride: "", rakevId: "" },
        { id: "manipulace_rakvi_nositky", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "ukony_zamestnancu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rezijni_naklady", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rakev", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "souprava", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "vystaveni_kytice_ks", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" }
      ],
    },
  },

  {
    id: "tpl_umrti_mimo_ck_obradni_sin_ck_pohrbeni_hrob",
    name: "Pohřbení do hrobu – úmrtí mimo ČK / obřadní síň ČK",
    prubehKey: "obradni_sin_ck_hrob",
    isSystem: true,
    data: {
      zaklad: {
        typZakazky: "pohreb",
        scenarUmrti: "mimo_ck",
      },
      prevoz: {
        dopravaMode: "km",
      },
      sluzby: [
        { id: "sjednani_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "prevoz_pausal_ck", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "cekaci_doba_zapocata_hod", mnozstvi: 2, cenaBezDphOverride: "", rakevId: "" },
        { id: "manipulace_rakvi_nositky", mnozstvi: 2, cenaBezDphOverride: "", rakevId: "" },
        { id: "ukony_zamestnancu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rizeni_pohrebu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rezijni_naklady", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "pronajem_obradni_sin", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "katafalk_obradni_sin", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "reprodukovana_hudba", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "umyvani_obleceni_ulozeni_ustrojeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rakev", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "souprava", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "ulozeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" }
      ],
    },
  },

  {
    id: "tpl_pohreb_standard",
    name: "Pohřbení do hrobu – standard",
    prubehKey: "obradni_sin_ck_hrob",
    isSystem: true,
    data: {
      zaklad: {
        typZakazky: "pohreb",
        scenarUmrti: "nemocnice_ck",
      },
      prevoz: {
        dopravaMode: "km",
      },
      sluzby: [
        { id: "sjednani_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "administrativa", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rakev", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "souprava", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "umyvani_obleceni_ulozeni_ustrojeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "holeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "manipulace_rakvi_nositky", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rizeni_pohrebu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "pronajem_obradni_sin", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "reprodukovana_hudba", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
      ],
    },
  },

  {
    id: "tpl_pohreb_kostel_hrob",
    name: "Pohřbení do hrobu – kostel",
    prubehKey: "kostel_hrob",
    isSystem: true,
    data: {
      zaklad: {
        typZakazky: "pohreb",
        scenarUmrti: "nemocnice_ck",
      },
      prevoz: {
        dopravaMode: "km",
      },
      sluzby: [
        { id: "sjednani_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "administrativa", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rakev", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "souprava", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "umyvani_obleceni_ulozeni_ustrojeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "holeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "manipulace_rakvi_nositky", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rizeni_pohrebu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "ulozeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" }
      ],
    },
  },

  {
    id: "tpl_alternativa_standard",
    name: "Alternativní rozloučení – standard",
    prubehKey: "alternativa_standard",
    isSystem: true,
    data: {
      zaklad: {
        typZakazky: "alternativa",
        scenarUmrti: "doma",
      },
      prevoz: {
        dopravaMode: "km",
      },
      sluzby: [
        { id: "sjednani_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "administrativa", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rakev", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "souprava", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "umyvani_obleceni_ulozeni_ustrojeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "holeni", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "manipulace_rakvi_nositky", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rizeni_pohrebu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "alternativni_misto_organizace", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "reprodukovana_hudba_mimo_sin", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
      ],
    },
  },
  {
    id: "tpl_obrad_s_urnou_standard",
    name: "Obřad s urnou – standard",
    prubehKey: "obrad_s_urnou_standard",
    isSystem: true,
    data: {
      zaklad: {
        typZakazky: "obrad_s_urnou",
        scenarUmrti: "nemocnice_ck",
      },
      prevoz: {
        dopravaMode: "pausal_ck",
      },
      sluzby: [
        { id: "sjednani_obradu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "administrativa", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "manipulace_urnou", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "rizeni_pohrebu", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "urne_standard", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "privezeni_urny_cb", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "pronajem_obradni_sin", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
        { id: "reprodukovana_hudba", mnozstvi: 1, cenaBezDphOverride: "", rakevId: "" },
      ],
    },
  },
];



export function findSystemTemplateForOrderSelection({
  typZakazky = "",
  scenarUmrti = "",
  prubehKey = "",
} = {}) {
  const typ = String(typZakazky || "").trim();
  const scenar = String(scenarUmrti || "").trim();
  const prubeh = String(prubehKey || "").trim();

  if (!typ || !prubeh) return null;

  const items = Array.isArray(SYSTEM_ORDER_TEMPLATES) ? SYSTEM_ORDER_TEMPLATES : [];

  const exact = items.find((tpl) => {
    const tplTyp = String(tpl?.data?.zaklad?.typZakazky || "").trim();
    const tplScenar = String(tpl?.data?.zaklad?.scenarUmrti || "").trim();
    const tplPrubeh = String(tpl?.prubehKey || tpl?.data?.zaklad?.prubehKey || "").trim();

    return tplTyp === typ && tplScenar === scenar && tplPrubeh === prubeh;
  });
  if (exact) return exact;

  const fallback = items.find((tpl) => {
    const tplTyp = String(tpl?.data?.zaklad?.typZakazky || "").trim();
    const tplPrubeh = String(tpl?.prubehKey || tpl?.data?.zaklad?.prubehKey || "").trim();
    return tplTyp === typ && tplPrubeh === prubeh;
  });

  return fallback || null;
}

export function getAllowedPrubehKeysForScenario(typZakazky = "", scenarUmrti = "") {
  const typ = String(typZakazky || "").trim();
  const scenar = String(scenarUmrti || "").trim();

  if (typ === "kremace") {
    if (scenar === "nemocnice_ck") {
      return ["obradni_sin_ck_nasledna_kremace", "kostel_nasledna_kremace"];
    }
    if (scenar === "doma") {
      return ["obradni_sin_ck_nasledna_kremace", "cb_krematorium_rozlouceni", "kostel_nasledna_kremace"];
    }
    if (scenar === "wagnerka") {
      return ["obradni_sin_ck_nasledna_kremace", "kostel_nasledna_kremace"];
    }
    if (scenar === "mimo_ck") {
      return ["obradni_sin_ck_nasledna_kremace", "cb_krematorium_rozlouceni", "kostel_nasledna_kremace"];
    }
    return [
      "obradni_sin_ck_nasledna_kremace",
      "cb_krematorium_rozlouceni",
      "kostel_nasledna_kremace",
    ];
  }

  if (typ === "kremace_bez_obradu") {
    return ["bez_obradu", "bez_obradu_urna", "bez_obradu_vystaveni"];
  }

  if (typ === "pohreb") {
    if (scenar === "nemocnice_ck") {
      return ["obradni_sin_ck_hrob", "kostel_hrob", "bez_obradu_hrob", "prime_pohrbeni_hrob"];
    }
    if (scenar === "doma") {
      return ["obradni_sin_ck_hrob", "kostel_hrob", "bez_obradu_hrob", "prime_pohrbeni_hrob"];
    }
    if (scenar === "wagnerka") {
      return ["obradni_sin_ck_hrob", "kostel_hrob", "bez_obradu_hrob", "prime_pohrbeni_hrob"];
    }
    if (scenar === "mimo_ck") {
      return ["obradni_sin_ck_hrob", "kostel_hrob", "bez_obradu_hrob", "prime_pohrbeni_hrob"];
    }
    return ["obradni_sin_ck_hrob", "kostel_hrob", "bez_obradu_hrob", "prime_pohrbeni_hrob"];
  }

  if (typ === "alternativa") {
    return ["alternativa_standard"];
  }

  if (typ === "obrad_s_urnou") {
    return ["obrad_s_urnou_standard"];
  }

  return [];
}

export function sanitizeTemplateOrderData(order = {}) {
  const x = JSON.parse(JSON.stringify(order || {}));

  if (!x.zaklad) x.zaklad = {};
  if (!x.vstupniInformace) x.vstupniInformace = {};
  if (!x.vypravitel) x.vypravitel = {};
  if (!x.zesnulaOsoba) x.zesnulaOsoba = {};
  if (!x.prevoz) x.prevoz = {};
  if (!x.obrad) x.obrad = {};
  if (!Array.isArray(x.sluzby)) x.sluzby = [];

  delete x.id;
  delete x.orderId;
  delete x.zakazkaId;
  delete x.createdAt;
  delete x.updatedAt;

  if (x.zaklad) {
    x.zaklad.zesnuly = "";
    x.zaklad.vypravitel = "";
    x.zaklad.poznamka = x.zaklad.poznamka || "";
    x.zaklad.datumSjednani = "";
  }

  if (x.vstupniInformace) {
    x.vstupniInformace.jmenoZesnuleho = "";
    x.vstupniInformace.prijmeniZesnuleho = "";
  }

  if (x.vypravitel) {
    x.vypravitel.jmeno = "";
    x.vypravitel.prijmeni = "";
  }

  if (x.zesnulaOsoba) {
    x.zesnulaOsoba.jmeno = "";
    x.zesnulaOsoba.prijmeni = "";
  }

  return x;
}
